import React from "react";
import { Row, Card, Divider, Col } from "antd";
import { PrimaryButton } from "components/common/Buttons";
import { useNavigate } from "react-router-dom";
import { CloseCircleOutlined } from "@ant-design/icons";

export default function Error({ next, prev }) {
  const navigate = useNavigate();

  const cerrarIr = () => {
    navigate("/declaraciones");
  };

  return (
    <>
      <div className="crear-declaracion__containerDeclaracion">
        <Col md={14}>
          <Card className="crear-declaracion__contenedorDeclaracion">
            <Row>
              <Col span={24}>
                <CloseCircleOutlined
                  style={{ fontSize: "33px", color: "#FF3C3E" }}
                />
              </Col>
            </Row>
            <div className="crear-declaracion__titleDeclaracion">
              Declaración
              <span style={{ fontWeight: "600" }}> Jurada</span>
            </div>
            <Divider />
            <Row>
              <Col span={24}>
                <p className="crear-declaracion__pText">
                  Tu declaración no ha podido ser recibida, Ha ocurrido un error en el registro.
                </p>
              </Col>
            </Row>
          </Card>
        </Col>
      </div>

      <Row justify="center" vgutter={8} className="crear-declaracion__botonera">
        <PrimaryButton
          width={239}
          height={38}
          type="Button"
          onButtonClick={() => cerrarIr()}
        >
          Cerrar
        </PrimaryButton>
      </Row>
    </>
  );
}
